import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import moment from 'moment-jalaali';
import Form from '../../Components/Boilerplates/Forms/Forms';
import Listview2 from '../../Components/Boilerplates/Listview/Listview2';
import useHttp from '../../hooks/http';

const uploadInputs = [
  {
    id: 'watershed_id',
    elementConfig: {
      type: 'text',
      placeholder: 'کد آبریز',
    },
    value: '',
    validation: {
      required: true,
      isNumeric: true,
    },
    valid: false,
    touched: false,
    queryParams: true,
  },
  {
    id: 'file',
    elementConfig: {
      type: 'file',
      accept: 'csv',
      placeholder: 'Lfile',
    },
    value: '',
    validation: {
      required: true,
    },
    valid: false,
    touched: true,
    single: true,
  },
];

const getInputs = [
  {
    id: 'watershed_id',
    elementConfig: {
      type: 'text',
      placeholder: 'کد آبریز',
    },
    value: '',
    validation: {
      required: true,
      isNumeric: true,
    },
    valid: false,
    touched: false,
    queryParams: true,
  },
  {
    id: 'start_date',
    elementConfig: {
      type: 'calendar',
      placeholder: 'تاریخ شروع',
    },
    value: moment(),
    requestValue: moment().format('YYYY-MM-DD'),
    validation: {
      required: true,
    },
    valid: true,
    touched: true,
    queryParams: true,
  },
  {
    id: 'end_date',
    elementConfig: {
      type: 'calendar',
      placeholder: 'تاریخ پایان',
    },
    value: moment(),
    requestValue: moment().format('YYYY-MM-DD'),
    validation: {
      required: true,
    },
    valid: true,
    touched: true,
    queryParams: true,
  },
];

const manageTypes = {
  Add: {
    type: 'form',
    inputs: {
      rainfall: [
        {
          id: 'watershed_id',
          elementConfig: {
            type: 'text',
            placeholder: 'کد آبریز',
          },
          value: '',
          validation: {
            required: true,
            isNumeric: true,
          },
          valid: false,
          touched: false,
        },
        {
          id: 'date',
          elementConfig: {
            type: 'calendar',
            placeholder: 'تاریخ',
          },
          value: moment(),
          validation: {
            required: true,
          },
          valid: true,
          touched: true,
        },
        {
          id: 'rainfall',
          elementConfig: {
            type: 'text',
            placeholder: 'بارش',
          },
          value: '',
          validation: {
            required: true,
            isNumeric: true,
          },
          valid: false,
          touched: false,
        },
      ],
      evaporation: [
        {
          id: 'watershed_id',
          elementConfig: {
            type: 'text',
            placeholder: 'کد آبریز',
          },
          value: '',
          validation: {
            required: true,
            isNumeric: true,
          },
          valid: false,
          touched: false,
        },
        {
          id: 'date',
          elementConfig: {
            type: 'calendar',
            placeholder: 'تاریخ',
          },
          value: moment(),
          validation: {
            required: true,
          },
          valid: true,
          touched: true,
        },
        {
          id: 'evaporation',
          elementConfig: {
            type: 'text',
            placeholder: 'تبخیر',
          },
          value: '',
          validation: {
            required: true,
            isNumeric: true,
          },
          valid: false,
          touched: false,
        },
      ],
    },
    body: (kind) => ({ watershed_item: kind }),
    url: () => 'add/watershed_detail',
    title: 'افزودن اطلاعات آبریز',
  },
  Upload: {
    type: 'form',
    inputs: {
      rainfall: uploadInputs,
      evaporation: uploadInputs,
    },
    url: (kind) => `upload/watershed_detail?watershed_item=${kind}`,
    title: 'آپلود اطلاعات آبریز',
  },
  Get: {
    type: 'form',
    inputs: {
      rainfall: getInputs,
      evaporation: getInputs,
    },
    method: 'GET',
    notjson: true,
    handleResponse: (response, setMessage) => {
      if (response.ok) {
        return response
          .blob()
          .then((data) => {
            const the = response.headers.get('Content-disposition');
            const thea = the.slice(the.indexOf('"') + 1, the.length - 1);

            return {
              blob: data,
              fileName: thea,
            };
          })
          .then(({ blob, fileName }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); //afterwards we remove the element again)
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        setMessage({ message: response.statusText, type: 'error' });
      }
    },
    btnText: 'دریافت',
    url: (kind) => `download/admin/watershed_detail?watershed_item=${kind === 'rainfall' ? 'RFL' : 'EVP'}`,
    title: 'دریافت اطلاعات آبریز',
  },
  List: {
    type: 'list',
    url: 'list_view/watershed_detail',
    list2: {
      evaporation: [{ en: 'value', fa: 'تبخیر' }],
      rainfall: [{ en: 'value', fa: 'بارش' }],
    },
  },
};

const Watershed = () => {
  const { type } = useParams();
  const { kind, date } = useLocation().state;
  const thisPageData = useMemo(() => ({ ...manageTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const [codes, setCodes] = useState();

  useEffect(() => {
    sendRequest('get/watershed/', 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      const the = [];

      data.forEach((element) => {
        the.push({ value: element.name, gainValue: element.id });
      });

      setCodes({
        elementConfig: {
          type: 'select',
          placeholder: 'کد آبریز',
          options: the,
        },
        indexValue: -1,
      });
      clear();
    }
  }, [error, isLoading, data, clear, setCodes]);

  const theReturn = useMemo(() => {
    switch (thisPageData.type) {
      case 'list':
        return (
          <Listview2
            list2={thisPageData.list2[kind.en]}
            url2={`${thisPageData.url + date}&watershed_item=${kind.en === 'rainfall' ? 'RFL' : 'EVP'}`}
          />
        );
      case 'form':
      default:
        const theInputs = [...thisPageData.inputs[kind.en]];
        if (codes) {
          theInputs[0] = { ...theInputs[0], ...codes };
        }

        return (
          <Form
            {...thisPageData}
            inputs={theInputs}
            url={thisPageData.url(kind.en)}
            body={(thisPageData.body && thisPageData.body(kind.en)) ?? null}
            pageTitle={thisPageData.title ? thisPageData.title + ` (${kind.fa})` : ''}
            header={{ Authorization: `Bearer ${token}` }}
            btnStyle={{
              borderRadius: '25px',
              width: '100px',
              marginLeft: '2rem',
              fontWeight: 'bold',
            }}
          />
        );
    }
  }, [thisPageData, token, kind, date, codes]);

  return theReturn;
};

export default Watershed;
